import React from 'react';

import LoadingScreen from '@zvuk-b2b/react-uikit/ui/LoadingScreen';

import { ModalHostRenderer } from '@shared/lib/modal';

import { appModalHost } from './appModalHost';

const MODAL_LOADING_SCREEN_DELAY_MS = 1000;

export const ModalRenderer: React.FC = () => (
  <ModalHostRenderer
    host={appModalHost}
    fallback={<LoadingScreen delay={MODAL_LOADING_SCREEN_DELAY_MS} />}
  />
);
